/*!
 * Copyright 2023 Thorne Health Lab. All rights reserved.
 */
import React, { Component } from 'react'
import injectSheet from 'react-jss'
import PropTypes from 'prop-types'
import { cloneDeep } from 'lodash'
import fp, { pipe } from 'lodash/fp'
import $ from 'jquery'
import moment from 'moment-timezone'
import { desktopBreakpoint } from '../../../constants'
import RightCarotIcon from '../../../assets/icons/carat_right.svg'
import LeftCarotIcon from '../../../assets/icons/carat_left.svg'
import style from './style'

/**
 * A calendar component
 */

class Calendar extends Component {
  constructor(props) {
    super(props)


    this.changeShowingIndex = this.changeShowingIndex.bind(this)
    this.getClassName = this.getClassName.bind(this)
    this.onDayClick = this.onDayClick.bind(this)
    this.onTimeClick = this.onTimeClick.bind(this)
    this.renderDayCards = this.renderDayCards.bind(this)
  }

  state = {
    selectedAppointment: null, // selected but not booked
    uncollapsedItems: {},
    itemsShownAtOnce: 4,
    itemsShownIndex: 0,
    isScrollClassAdded: false
  }

  onScroll = () => {
    // fix header when scrolling
    // 25 is main-contentpadding, 25 is sectiontitle padding

    if (
      $('.main-content').scrollTop() > $('.section-title').height() + 50 &&
      !this.state.isScrollClassAdded
    ) {
      $('.month-wrapper').addClass('fixed-scroll-month')
      $('.cards-wrapper').addClass('fixed-scroll-padding')
      this.setState({
        isScrollClassAdded: true
      })
    } else if (
      $('.main-content').scrollTop() < $('.section-title').height() + 50 &&
      this.state.isScrollClassAdded
    ) {
      $('.month-wrapper').removeClass('fixed-scroll-month')
      $('.cards-wrapper').removeClass('fixed-scroll-padding')

      this.setState({
        isScrollClassAdded: false
      })
    }
  }

  componentDidMount() {
    const mainContent = document.getElementsByClassName('main-content')[0]
    mainContent.addEventListener('scroll', this.onScroll)
    this.onScroll()
  }

  componentWillUnmount() {
    const mainContent = document.getElementsByClassName('main-content')[0]
    mainContent.removeEventListener('scroll', this.onScroll)
  }

  render() {
    const { renderDayCards, props, changeShowingIndex, state } = this
    const { timeslots, classes, onIncreaseMonth, onDecreaseMonth } = props
    const { itemsShownAtOnce, itemsShownIndex } = state
    const month = timeslots[itemsShownIndex]
      ? timeslots[itemsShownIndex].month
      : moment(props.month).format('MMMM YYYY')

    return (
      <div className={classes.base}>
        <div className={classes.datesWrapper}>
          <span className={`${classes.monthWrapper} month-wrapper`}>
            <div onClick={onDecreaseMonth} className={classes.monthCarot}>
              <img src={LeftCarotIcon} alt="left carot" />
            </div>
            <h1 className={classes.monthName}>
              <span>{month}</span>
            </h1>
            <div onClick={onIncreaseMonth} className={classes.monthCarot}>
              <img src={RightCarotIcon} alt="right carot" />
            </div>
          </span>
          <div className={`${classes.cardsWrapper} cards-wrapper`}>
            <div className={classes.carotContainer}>
              <div
                className={classes.carot}
                onClick={() => changeShowingIndex(-itemsShownAtOnce)}
              >
                <img src={LeftCarotIcon} alt="left carot" />
              </div>
            </div>
            {timeslots.length > 0 ? (
              renderDayCards()
            ) : (
              <div className="no-appointments">
                No Appointments Left in this Month
              </div>
            )}
            <div className={classes.carotContainer}>
              <div
                className={classes.carot}
                onClick={() => changeShowingIndex(itemsShownAtOnce)}
              >
                <img src={RightCarotIcon} alt="right carot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  changeShowingIndex(numToChangeIndex) {
    const { timeslots } = this.props

    this.setState(prevState => {
      const { itemsShownAtOnce, itemsShownIndex } = prevState

      let newIndex = itemsShownIndex + numToChangeIndex

      if (newIndex > timeslots.length - itemsShownAtOnce) {
        newIndex = timeslots.length - itemsShownAtOnce
      }
      if (newIndex < 0) newIndex = 0

      return {
        itemsShownIndex: newIndex
      }
    })
  }

  getClassName(hideOnMobile, appointment) {
    const { classes } = this.props
    const { selectedAppointment } = this.state
    const { availableTime, defaultTime } = appointment
    const availableHour = moment(availableTime).format('h:mm a')

    let className = ''
    const isDisabledTime = defaultTime !== availableHour
    const isActiveTime = fp.isEqual(appointment, selectedAppointment)
    let isUpcomingTime = false

    if (this.props.upcomingVisit) {
      const upcomingDate = moment(this.props.upcomingVisit.date)
        .tz('America/New_York')
        .format('YYYY-MM-DD')

      const upcomingHour = moment(this.props.upcomingVisit.date)
        .tz('America/New_York')
        .format('h:mm a')

      const availableDate = moment(availableTime)
        .tz('America/New_York')
        .format('YYYY-MM-DD')

      isUpcomingTime =
        upcomingDate === availableDate && upcomingHour === defaultTime
    }

    if (hideOnMobile) className = `${className} ${classes.hideOnMobile}`
    if (isDisabledTime) className = `${className} ${classes.isDisabledTime}`
    if (isActiveTime && !isDisabledTime) {
      className = `${className} ${classes.isActiveTime}`
    }
    if (isUpcomingTime) className = `${className} ${classes.isUpcomingTime}`

    return className
  }

  onDayClick(timeslotIndex) {
    const uncollapsedItems = cloneDeep(this.state.uncollapsedItems)
    const shouldShowItem = !uncollapsedItems[timeslotIndex]
    uncollapsedItems[timeslotIndex] = shouldShowItem
    this.setState({ uncollapsedItems })
  }

  onTimeClick(e, appointment) {
    e.stopPropagation()
    const { availableTime, defaultTime } = appointment
    const { onSelection } = this.props

    const availableHour = availableTime
      ? moment(availableTime).format('h:mm a')
      : undefined
    const isDisabledTime = defaultTime !== availableHour
    let isUpcomingTime = false
    if (this.props.upcomingVisit) {
      const upcomingDate = moment(this.props.upcomingVisit.date)
        .tz('America/New_York')
        .format('YYYY-MM-DD')

      const upcomingHour = moment(this.props.upcomingVisit.date)
        .tz('America/New_York')
        .format('h:mm a')

      const availableDate = moment(availableTime)
        .tz('America/New_York')
        .format('YYYY-MM-DD')

      isUpcomingTime =
        upcomingDate === availableDate && upcomingHour === defaultTime
    }
    if (isDisabledTime || isUpcomingTime) return

    this.setState({ selectedAppointment: appointment }, () => {
      const longFormattedDate = moment(
        this.state.selectedAppointment.availableTime
      ).format('dddd, MMMM Do [at] h:mm a')

      const selectedAppointment = {
        longFormattedDate,
        time: this.state.selectedAppointment.availableTime
      }

      if (onSelection) onSelection(selectedAppointment)

      if (window.innerWidth >= desktopBreakpoint) {
        setTimeout(() => {
          const button = document.querySelector('.timeslot-btn')
          if (button) button.scrollIntoView({ behavior: 'smooth' })
        }, 10)
      }
    })
  }

  renderDayCards() {
    const { getClassName, onDayClick, onTimeClick, props, state } = this
    const { itemsShownIndex, itemsShownAtOnce } = state
    const { classes, isMobile } = props

    const sortSlots = pipe([
      fp.get('timeslots'),
      fp.orderBy(t => moment(t.times[0]), ['asc'])
    ])

    const orderedTimeslots = sortSlots(props)
    const shownTimeslots = isMobile
      ? orderedTimeslots
      : orderedTimeslots.splice(itemsShownIndex, itemsShownAtOnce)

    return shownTimeslots.map((timeslot, timeslotIndex) => {
      const { dayName, numberOfMonth, defaultTimes } = timeslot

      return (
        <div
          className={classes.dayCard}
          onClick={() => onDayClick(timeslotIndex)}
          key={timeslotIndex}
        >
          <div className={classes.dayTitle}>
            <span>{dayName}</span>
            <span>{numberOfMonth}</span>
          </div>
          <ul>
            {defaultTimes.map((defaultTime, timeIndex) => {
              // const hideOnMobile = !uncollapsedItems[timeslotIndex]

              const isAvail = timeslot.times.filter(
                time => moment(time).format('h:mm a') === defaultTime
              )

              const appointment = {
                defaultTime,
                availableTime: isAvail[0]
              }

              // DO THIS IN CASE  TIMES HAS LESS THAN 5 TIMES... IM SO SORRY

              return (
                <li
                  key={timeIndex}
                  // className={getClassName(hideOnMobile, appointment)}
                  className={getClassName(false, appointment)}
                  onClick={e => onTimeClick(e, appointment)}
                >
                  <span>{defaultTime}</span>
                </li>
              )
            })}
          </ul>
        </div>
      )
    })
  }
}

Calendar.propTypes = {
  timeslots: PropTypes.array,
  onSelection: PropTypes.func,
  isMobile: PropTypes.bool,
  upcomingVisit: PropTypes.object,
  onIncreaseMonth: PropTypes.func,
  onDecreaseMonth: PropTypes.func,
  isGettingDates: PropTypes.bool,
  month: PropTypes.string,
  classes: PropTypes.object
}

const styleAndTheme = () => style

export default injectSheet(styleAndTheme)(Calendar)
